import Marquee from "react-fast-marquee";

const WORDS = [
  "Lavage Extérieur",
  "Lavage Intérieur",
  "Detailing Premium",
  "Protection Céramique",
  "Rénovation Phares",
  "Lavage Vapeur",
];

export const Ribbon = () => {
  return (
    <div data-testid="marquee-ribbon" className="border-y border-white/10 bg-[var(--bg-1)] py-6 sm:py-8">
      <Marquee speed={38} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="text-stroke font-display font-bold uppercase text-4xl sm:text-6xl tracking-tight px-8">
              {w}
            </span>
            <span className="text-[var(--blue)] text-3xl sm:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
